// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".errors-list{margin-top:35px}\n", "",{"version":3,"sources":["/home/sysadmin/apps/rsee-panel/src/components/failedMesasgesList/styles.scss"],"names":[],"mappings":"AAAA,aACE,eAAgB","file":"styles.scss","sourcesContent":[".errors-list {\n  margin-top: 35px;\n}"]}]);
// Exports
module.exports = exports;
